<div style="margin: 92px auto; width: 12%;" >
    <img src="../../../assets/img/loader.gif" width="99px"/>
</div>